export const PACKAGE_NAME = 'jira-navigation-apps-sidebar-nav4-more-projects';
export const TEAM_NAME = 'jira-cosmos';
